import {
  FETCH_DASHBOARD_STATS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
